<template>
  <div v-loading="isLoading">
    <el-table
      stripe
      border
      :data="filteredGroups">
      <el-table-column
        label="グループ名"
        sortable
        prop="name" />
      <el-table-column
        label="ライセンスコード"
        sortable
        prop="licenseCode" />
      <el-table-column
        label="契約状況">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.hasCrmLicense">crm</el-tag>
          <el-tag type="primary" v-if="scope.row.hasSalesReportLicense">sr</el-tag>
          <el-tag type="warning" v-if="scope.row.hasReserveLicense">reserve</el-tag>
          <el-tag type="success" v-if="scope.row.hasSalesCsvExportLicense">sr_csv_export</el-tag>
          <el-tag type="primary" v-if="scope.row.hasCustomerCsvImportLicense">crm_csv_import</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        width="240"
        align="center"
        label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click="changeGroup(scope.row)">切り替え</el-button>
          <el-button type="warning" @click="changeLoginAsGroup(scope.row)">ログイン</el-button>
        </template>
      </el-table-column>
    </el-table>
    {{ filteredGroups.length }}件 (総計 {{ total }}件)
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'ShopSelectGroupTable',
  data () {
    return {
      isLoading: false,
      total: 0,
      groups: [],
    }
  },
  computed: {
    filteredGroups () {
      return this.groups
    },
  },
  methods: {
    ...mapActions({
      setAsGroup: 'account/setAsGroup',
      changeLogin: 'account/changeLogin',
    }),
    fetchData () {
      this.isLoading = true
      this.$request.groups.all(groups => {
        this.total = groups.length
        this.groups = groups
      }).finally(() => {
        this.isLoading = false
      })
    },
    changeGroup (row) {
      this.setAsGroup(row.pk).then(res => {
        this.$router.push({name: 'Home'})
      })
    },
    changeLoginAsGroup (row) {
      this.isLoading = true
      this.$request.admin.auth.changeLoginAsGroup(row.pk).then(res => {
        return this.changeLogin(res.body.token)
      }).then(() => {
        this.$router.push({name: 'Home'})
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
  mounted () {
    this.fetchData()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ShopSelect/GroupTable.vue